import { Outlet } from 'react-router-dom';
import MobileNav from './MobileNav';
import WifiWarning from './WifiWarning';

const Layout = (): JSX.Element => {
  return (
    <>
      <MobileNav />
      <WifiWarning />
      <main className="w-[calc(100vw-16px)] mx-2 md:w-auto md:max-w-md bg-white rounded-none md:rounded-2xl shadow-none md:shadow-lg p-3 md:p-6 mb-0 md:mb-8 relative overflow-hidden">
        <Outlet />
      </main>
    </>
  );
};

export default Layout; 